export const DARK_ORANGE = '#ba8d67';
export const LIGHT_GRAY = '#bdbdbd';
export const DARK_GRAY = '#757575';
export const BLACK = '#000000';
export const WHITE = '#FFFFFF';
